module.exports = __webpack_public_path__ + "static/media/satellite-dish.72161274.svg";